import { render } from "./WrongTimezone.vue?vue&type=template&id=326d5d50"
import script from "./WrongTimezone.vue?vue&type=script&lang=js"
export * from "./WrongTimezone.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__